module.exports = __webpack_public_path__ + "media/images/area/area_iwateM400-56b468e943cbbc9b26824e06e2058d4e.jpg";